import { useQuery } from 'react-query';
import { BookingRange, CustomerBooking } from '../../types';
import {
    CustomerBookingsStaleTimeInMilliseconds,
    customerBookingsQueryKey,
    fetchCustomerBookings
} from './customerBookingsQuery';

export function useCustomerBookingsQuery(range: BookingRange | null) {
    return useQuery<CustomerBooking[]>(
        customerBookingsQueryKey(range),
        () => fetchCustomerBookings(range!),
        {
            enabled: range !== null,
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            refetchOnMount: 'always',
            staleTime: CustomerBookingsStaleTimeInMilliseconds
        }
    );
}
